function c(a) {
  return "callback" in a;
}
export {
  c as hasCallback
};
